/* Orion starfield: monochrome canvas galaxy with depth, drift and parallax.
   Static frame for reduced motion / save-data; simplified on low-power devices. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var low = root.classList.contains('perf-low');
  var saveData = navigator.connection && navigator.connection.saveData;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  function Field(canvas) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    if (!this.ctx) return;
    this.density = Math.max(10, Math.min(100, parseFloat(canvas.dataset.density) || 60)) / 100;
    this.scrollDepth = canvas.hasAttribute('data-scroll-depth');
    this.t = 0; this.px = 0; this.py = 0; this.tx = 0; this.ty = 0;
    this.visible = true; this.running = false; this.last = 0;
    this.frame = this.frame.bind(this);
    this.resize();
    var self = this, rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { self.resize(); }, 180); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; self.toggle(); }).observe(canvas);
    }
    document.addEventListener('visibilitychange', function () { self.toggle(); });
    if (reduce.addEventListener) reduce.addEventListener('change', function () { self.toggle(); });
    if (finePointer && !low) {
      window.addEventListener('pointermove', function (e) { self.tx = e.clientX / window.innerWidth - 0.5; self.ty = e.clientY / window.innerHeight - 0.5; }, { passive: true });
    }
    var host = canvas.parentElement;
    if (host && host.parentElement) host.parentElement.classList.add('has-starfield');
    this.toggle();
  }

  Field.prototype.animated = function () { return !reduce.matches && !saveData; };

  Field.prototype.resize = function () {
    var r = this.c.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, low ? 1 : 1.75);
    this.w = Math.max(1, r.width); this.h = Math.max(1, r.height);
    this.c.width = Math.round(this.w * dpr); this.c.height = Math.round(this.h * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var n = Math.round((this.w * this.h) / 900 * this.density * (low ? 0.45 : 1));
    n = Math.min(n, low ? 650 : 2600);
    this.stars = [];
    for (var i = 0; i < n; i++) {
      var z = Math.pow(Math.random(), 2.2);
      this.stars.push({
        x: Math.random() * this.w, y: Math.random() * this.h, z: z,
        r: 0.25 + z * 1.35,
        a: 0.18 + Math.random() * 0.5 + z * 0.35,
        tw: Math.random() * 6.283, ts: 0.3 + Math.random() * 1.6,
        v: 0.004 + z * 0.03,
        bright: z > 0.86 && Math.random() > 0.4
      });
    }
    this.neb = this.nebula();
    this.draw(0);
  };

  Field.prototype.nebula = function () {
    var o = document.createElement('canvas');
    var w = Math.max(2, Math.round(this.w / 2)), h = Math.max(2, Math.round(this.h / 2));
    o.width = w; o.height = h;
    var g = o.getContext('2d'), m = Math.max(w, h);
    var blobs = [[0.7, 0.42, 0.55, 0.075], [0.28, 0.68, 0.42, 0.05], [0.52, 0.5, 0.3, 0.045], [0.86, 0.78, 0.34, 0.035], [0.12, 0.2, 0.3, 0.03]];
    blobs.forEach(function (b) {
      var gr = g.createRadialGradient(b[0] * w, b[1] * h, 0, b[0] * w, b[1] * h, b[2] * m);
      gr.addColorStop(0, 'rgba(201,201,201,' + b[3] + ')');
      gr.addColorStop(0.45, 'rgba(119,119,119,' + (b[3] * 0.45) + ')');
      gr.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = gr; g.fillRect(0, 0, w, h);
    });
    g.save(); g.translate(w * 0.5, h * 0.5); g.rotate(-0.42);
    for (var i = 0; i < (low ? 220 : 900); i++) {
      var dx = (Math.random() - 0.5) * w * 1.4, dy = (Math.random() - 0.5) * h * 0.22 * (1 + Math.random());
      g.fillStyle = 'rgba(245,245,245,' + (Math.random() * 0.06) + ')';
      g.fillRect(dx, dy, 1, 1);
    }
    g.restore();
    return o;
  };

  Field.prototype.draw = function (dt) {
    var ctx = this.ctx, w = this.w, h = this.h, moving = this.animated();
    ctx.clearRect(0, 0, w, h);
    ctx.drawImage(this.neb, 0, 0, w, h);
    this.px += (this.tx - this.px) * 0.04; this.py += (this.ty - this.py) * 0.04;
    var sy = (this.scrollDepth && moving) ? Math.min(window.scrollY, h * 1.5) : 0;
    for (var i = 0; i < this.stars.length; i++) {
      var s = this.stars[i];
      if (moving) { s.x -= s.v * dt * 0.06; if (s.x < -4) { s.x = w + 4; s.y = Math.random() * h; } }
      var tw = moving ? 0.72 + 0.28 * Math.sin(this.t * s.ts + s.tw) : 1;
      var x = s.x - this.px * s.z * 22;
      var y = s.y - this.py * s.z * 14 - sy * (0.08 + s.z * 0.35);
      y = ((y % h) + h) % h;
      ctx.globalAlpha = Math.min(1, s.a * tw);
      ctx.fillStyle = s.z > 0.6 ? '#ffffff' : '#c9c9c9';
      ctx.beginPath(); ctx.arc(x, y, s.r, 0, 6.2832); ctx.fill();
      if (s.bright) {
        ctx.globalAlpha = s.a * tw * 0.14;
        ctx.beginPath(); ctx.arc(x, y, s.r * 4, 0, 6.2832); ctx.fill();
        ctx.globalAlpha = s.a * tw * 0.35;
        ctx.fillRect(x - s.r * 5, y - 0.25, s.r * 10, 0.5); ctx.fillRect(x - 0.25, y - s.r * 5, 0.5, s.r * 10);
      }
    }
    ctx.globalAlpha = 1;
  };

  Field.prototype.frame = function (now) {
    if (!this.running) return;
    var step = low ? 33 : 16;
    var dt = this.last ? now - this.last : 16;
    if (dt >= step) { this.t += dt / 1000; this.draw(Math.min(dt, 64)); this.last = now; }
    requestAnimationFrame(this.frame);
  };

  Field.prototype.toggle = function () {
    var should = this.visible && !document.hidden && this.animated();
    if (should && !this.running) { this.running = true; this.last = 0; requestAnimationFrame(this.frame); }
    else if (!should) { this.running = false; this.draw(0); }
  };

  function init(scope) {
    (scope || document).querySelectorAll('canvas[data-starfield]').forEach(function (c) {
      if (c._field) return; c._field = new Field(c);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.OrionStarfield = { init: init };
})();
